<div class="skeleton-container">
  <div class="skeleton-row" *ngFor="let _ of rows()" @fadeInOut></div>
</div>
